(() => {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const GAP = 20;

  const scrollToTarget = (target, updateHash) => {
    const top = target.getBoundingClientRect().top + window.scrollY - GAP;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduced.matches ? 'auto' : 'smooth',
    });

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });

    if (updateHash && target.id) {
      history.replaceState(null, '', `#${target.id}`);
    }
  };

  const targetFromHash = (hash) => {
    const id = decodeURIComponent(hash.slice(1));
    return id ? document.getElementById(id) : null;
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey) return;

    const link = event.target.closest('a[href*="#"]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    if (link.host !== window.location.host || link.pathname !== window.location.pathname) return;

    const target = targetFromHash(link.hash);
    if (!target) return;

    event.preventDefault();
    scrollToTarget(target, true);
  });

  const applyHash = () => {
    const target = targetFromHash(window.location.hash);
    if (!target) return;
    window.requestAnimationFrame(() => scrollToTarget(target, false));
  };

  window.addEventListener('load', applyHash);
  window.addEventListener('hashchange', applyHash);
})();
